// handles the rendering of updated sections
const renderContents = (parsedState, sectionsToRender) => {
    sectionsToRender.forEach((section) => {
    // get the element present in current DOM to update
    const sectionElement = section.selector
      ? document.querySelector(section.selector)
      : document.getElementById(section.id);
//OPTIONAL: this.querySelector(section.id).classList.contains('is-empty') && this.querySelector(section.id).classList.remove('is-empty')
// if(section.id === 'cart-drawer' && !InnerHTML.querySelector('.cart-items')) document.querySelector(section.id).classList.add('is-empty');
    if (parsedState[section.id])
      // get the innerHTML of fetched updated element based on id and selector
      sectionElement.innerHTML = getSectionInnerHTML(
        parsedState[section.id],
        section.selector
      );
  });
};

const getSectionInnerHTML = (html, selector) =>
  // parses string to HTML
  new DOMParser()
    .parseFromString(html, "text/html")
    .querySelector(
         selector
    ).innerHTML;

// adds a event listener to the custom event
document.addEventListener("cart:refresh", () => {
  checkSectionConditionsAndUpdate();
});

// checks for all the length of sections to fetch and update
// because max length which API can fetch is 5 only
const checkSectionConditionsAndUpdate = () => {
  const isCartPage = window.location.pathname.includes("/cart");

  const sectionsConfig = [
    ...getCommonSectionsToRender(),
    ...(isCartPage
      ? getCartPageSectionsToRender()
      : getCartDrawerSectionsToRender()),
  ];

  const sectionUpdateConfig = {
    sectionsLimitReached: false,
    sectionsConfig,
  };

  // conditions for length
  if (sectionsConfig.length > 5) {
    let startRemovePosition = 0;

    for (let i = 0; i < Math.ceil(sectionsConfig.length / 5); i += 1) {
      getSectionsAndUpdate({
        ...sectionUpdateConfig,
        startRemovePosition,
        sectionsLimitReached: true,
      });
      startRemovePosition += 5;
    }
  } else getSectionsAndUpdate(sectionUpdateConfig);
};

// fetches the sections and updates them accordingly
const getSectionsAndUpdate = async ({
  sectionsLimitReached,
  startRemovePosition = 0,
  sectionsConfig,
}) => {
  // concatenates sections IDs to a string
  const sectionsToFetch = (
    sectionsLimitReached
      ? sectionsConfig.slice(
          startRemovePosition,
          sectionsConfig.length < startRemovePosition + 5
            ? sectionsConfig.length
            : startRemovePosition + 5
        )
      : sectionsConfig
  ).reduce(
    (curr, section, i) => (i ? `${curr},${section.id}` : curr),
    sectionsConfig[startRemovePosition].id
  );

  const sectionData = await fetch(
    `${window.location.pathname}?sections=${sectionsToFetch}`
  );
  const data = await sectionData.json();

  renderContents(data, sectionsConfig);
};

const getCommonSectionsToRender = () => {
  return [];
};

const getCartPageSectionsToRender = () => {
  return [
    {
      id: "template--20378982482125__main",
      selector: "#shopify-section-template--20378982482125__main",
    }
  ];
};